import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import './css/FinalReview.css'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
export default function FinalReview (props) {
  const navigate = useNavigate()
  const { open, setOpen, name, last, email, val, str } = props

  const handleClose = () => {
    setOpen(false)
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  }

  const Fullname = name + ' ' + last
  return (
    <div data-aos='zoom-out-down'>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby='keep-mounted-modal-title'
        aria-describedby='keep-mounted-modal-description'
        className='order-final'
      >
        <Box sx={style}>
          <Typography id='titlemodal' variant='h6' component='h2'>
            Your Information
          </Typography>

          <div className='feature'>
            <div className='row-one'>
              <div className='text-col-full'>
                <h2>{Fullname}</h2>
                <p style={{ width: '90%', fontWeight: '300' }}> </p>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span style={{ fontWeight: '700' }}>Pricing:</span>
                  {str !== ''}
                  <p style={{ width: '75%' }}>{str}</p>
                </div>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span style={{ fontWeight: '700' }}>Email:</span>
                  <p style={{ width: '75%' }}>{email}</p>
                </div>
              </div>
              <div className='img-col-full'>
                <img
                  alt='..'
                  src='Review.png'
                  style={{ height: '15rem', padding: '30px' }}
                />
              </div>
            </div>
          </div>

          <center>
            <button
              type='submit'
              class='submit'
              onClick={() => {
                str === 'Free'
                  ? window.open('http://localhost:9007/request', '_blank')
                  : navigate('/payment')
              }}
            >
              Confirm your Order
            </button>
          </center>
        </Box>
      </Modal>
    </div>
  )
}
